import { render, staticRenderFns } from "./FooterModal.vue?vue&type=template&id=15d31308&scoped=true&"
import script from "./FooterModal.vue?vue&type=script&lang=js&"
export * from "./FooterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d31308",
  null
  
)

export default component.exports